<template>
  <div class="w-100">
    <!-- FORCE BIND ALERT-->
    <!-- Navigation and related information START -->
    <div id="nav-info" role="navigation" class="container-fluid fixed-top w-100 px-0">
      <interview-navi :navData="pageData"></interview-navi>
    </div>
    <div role="main" :class="{'quote-panel-open': quotePanelStatus, 'quote-panel-close': !quotePanelStatus, 'bundle' : flowType === 'bundle' || flowType === 'cabundle' || flowType === 'rabundle'}">
      <!-- REQUIRED-->
      <div class="required row mx-0">
        <div class="col-12 px-0 text-left qrp-text-muted">
          <span class="star">*</span>Required to run carrier quotes.
          <hr />
        </div>
      </div>

      <!-- TOP Instruction SECTION -->
      <div class="d-flex justify-content-center mx-auto mb-1" v-if="blurbs.formtop && blurbs.formtop.visible">
        <div class="alert alert-primary my-0 py-2 w-50" role="note">
          <div class="row no-gutters">
            <div class="d-inline-block pr-2 my-auto">
              <img width="25px" height="25px" src="../../../../assets/info-circle-blue.svg" alt="info">
            </div>
            <div class="col d-inline-block my-auto smaller-font-content" v-html="blurbs.formtop.content">
            </div>
          </div>
        </div>
      </div>
      <!-- TOP Instruction SECTION END -->

      <div class="row no-gutters mx-0">
        <div class="col-12">
          <form class="needs-validation" @keydown.enter.prevent="submitted">
            <div class="form-row mx-0">
              <div class="col-12 col-md-6 px-0">
                <div class="mr-md-4">
                  <div class="py-2 pl-2 mt-1 mb-2 text-white bg-ltblue rounded-top" v-if="colsArray[0] !== ''">
                    {{ colsArray[0] }}</div>
                  <!--FORM BLOCK-->
                  <form-block v-for="(item, key) in pageFieldsArray_1" :key='key' v-if="item.section === colsArray[0]"
                    :formdata='item' :class="getFieldCss(item)" :ref='item.field_name'></form-block>
                </div>
              </div>
              <div class="col-12 col-md-6 px-0">
                <div class="ml-md-4">
                  <div class="py-2 pl-2 mt-1 mb-2 text-white bg-ltblue rounded-top" v-if="colsArray[1] !== ''">
                    {{ colsArray[1] }}</div>
                  <!--FORM BLOCK-->
                  <form-block v-for="(item, key) in pageFieldsArray_2" :key='key' v-if="item.section === colsArray[1]"
                    :formdata='item' :class="getFieldCss(item)" :ref='item.field_name'></form-block>
                </div>
              </div>
            </div>

            <hr class="mx-2">
            <!-- bottom Instruction SECTION -->
            <div class="d-flex justify-content-center mx-auto" v-if="blurbs.formbottom && blurbs.formbottom.visible">
              <div class="alert alert-primary my-0 py-2 w-50" role="note">
                <div class="row no-gutters">
                  <div class="d-inline-block pr-2 my-auto">
                    <img width="25px" height="25px" src="../../../../assets/info-circle-blue.svg" alt="info">
                  </div>
                  <div class="col d-inline-block my-auto smaller-font-content" v-html="blurbs.formbottom.content">
                  </div>
                </div>
              </div>
            </div>
            <!-- bottom Instruction SECTION END -->

            <div class="form-row justify-content-center mx-0 my-3"
              v-if="getContinueLabelName() != '' && continueEnabled">
              <div class="col-8 text-center">
                <button type="submit" class="btn btn-primary"
                  @click.prevent="submitted">{{ getContinueLabelName() }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div>
        <div class="row m-3" style="display: none;" id="sandboxed-cc">
          <form-block :formdata="creditCardData"></form-block>
        </div>
      </div>
      <dev-auto-fill :pageData="pageData"></dev-auto-fill>
    </div>
    <!-- Bound Policy Alert -->
    <form-alerts
      v-if="renderAlert && $store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status === 'Bound'"
      :pageData="policyBindError" :class="{'policy-bound-alert': true, 'margin-25' : quotePanelStatus}"></form-alerts>
  </div>
</template>

<script>
/**
 * NamedInsured Interview Page is the first step in the interview process after a new quote is initiated
 * from the Search Page: on the Search Page, to create a New Quote you have to enter a zip code. That zip code
 * is carried over to this NamedInsured Interview Page and that zip code field AND the state select boxes are
 * disabled and do NOT allow user manipulation.
 *
 * To see the info sent from the server to render everything on this page, find 'fetchData.getPageData' and log to console the response.
 * For every field that is sent by the server, we create a <form-element> Vue component and attach to the page.
 *
 * Vee Validate is used with custom rules sent by the server to validate fields that need it.
 *
 * If there is an associated "Rule" with a field, then a POST request will be sent to the server w/the field values and the server
 * will send back what fields to update.
 * As you can see below we 'import { rulesMixin }' but the actual POST Request to the server is made in a child <form-element> component:
 * 'FormElement.vue: self.$parent.sendPost(self.apiRule.url)' and triggered by onchanges and onblurs to form elements.
 *
 * Forward progress to the next step in the Interview process (Vehicles) is made by clicking the 'Save & Continue to Vehicles' button.
 * If there are fields that do not meet the validation rules sent from the server, then you will not be able to progress forward in
 * the Interview Process.
 */
import FormBlock from '../../../presentational/FormBlock';
import FormAlerts from '../../../presentational/alerts/FormAlerts';
import InterviewNavigation from '../../shared/Navigation';
import InterviewNavigationTitle from '../../shared/NavigationTitle';
import fetchData from '../../../../services/fetchData';
import User from '../../../../services/User';
import common from '../../../../services/common';
import { rulesMixin } from '../../../../mixins/rulesMixin';
import { pageMixin } from '../../../../mixins/pageMixin';
import { stickyDivMixin } from '../../../../mixins/stickyDivMixin';

export default {
  mixins: [pageMixin, rulesMixin, stickyDivMixin],
  data() {
    return {
      flowType: '',
      pageFieldsArray: [],
      pageFieldsArray_1: [], // TODO: Use data to split into columns
      pageFieldsArray_2: [],
      blurbs: [],
      pageData: {
        page_name: '',
        buttons: [],
        fields: [],
        blurbs: [],
        quote_summary: {},
      },
      colsArray: [],
      /* eslint-disable */
      creditCardData: {
          "field_name": "QTE_CreditCardNumber",
          "field_type": "sandboxed-cc",
          "label": "Credit Card Number",
          "field_value": "",
          "group_id": 1,
          "index": null,
          "sub_index": null,
          "display_order": 70,
          "section_display_order": 0,
          "help_text": "",
          "sub_text": "",
          "placeholder": "XXXX-XXXX-XXXX-XXXX",
          "visible": true,
          "is_quote_summary_field": false,
          "is_enabled": true,
          "is_required": true,
          "script": "",
          "max_length": 16,
          "section": "Billing Information",
          "section_type": "Accordion",
          "sub_section": "Today's Payment: Debit/Credit Card",
          "sub_section_type": "",
          "sub_index_section": "",
          "sub_index_section_type": "",
          "rules": [
              {
                  "rule_type": "js",
                  "trigger": "onsubmit",
                  "rule_name": "SafecoCreditCard",
                  "rule": "{\"required\": true, \"numeric\": true, \"min\": 15, \"max\": 16}",
                  "rule_url": ""
              }
          ],
          "values": [],
          "has_error": false,
          "error": ""
      },
      renderAlert : false,
    };
  },
  components: {
    FormBlock,
    FormAlerts,
    interviewNavi: InterviewNavigation,
    interviewNaviTitle: InterviewNavigationTitle,
  },
  methods: {
    /**
     * check if inline fields available to display. Add class accordingly
     */
    getFieldCss(data) {
      let formClassSize = {};
      const formType = data.field_type;
      const formLayout = formType.split('_')[2];
      if (formLayout === 'inline' || formLayout === 'right') {
        formClassSize = {
          'd-inline-block': true,
          'mx-2': true,
          'form-group': true,
        };
      } else {
        formClassSize = {
          'mx-2': true,
          'form-group': true,
        };
      }
      return formClassSize;
    },
  },
  created() {
    // add checks if user is not already in AVB D
    
    ///////////////////////
    const agName = sessionStorage.getItem("userFirstName");
    if (!agName) {
    User.init().then((res) => {
      this.productButtonsData = Object.create(this.insuranceType);
      const productOrder = [1, 21, 18, 12, QRP.PRODUCTS.HA_BUNDLE, QRP.PRODUCTS.CA_BUNDLE, QRP.PRODUCTS.RA_BUNDLE];
      this.userProfileData.firstName = sessionStorage.getItem('userFirstName');
      this.userProfileData.lastName = sessionStorage.getItem('userLastName');
      console.log('this.userProfileData', this.userProfileData);
      if(res.productAccess.includes(QRP.PRODUCTS.AUTO) && res.productAccess.includes(QRP.PRODUCTS.HOME)) {
        res.productAccess.push(QRP.PRODUCTS.HA_BUNDLE);//TODO
      }
      if(res.productAccess.includes(QRP.PRODUCTS.CONDO) && res.productAccess.includes(QRP.PRODUCTS.AUTO)) {
        res.productAccess.push(QRP.PRODUCTS.CA_BUNDLE);//TODO
      }
      if(res.productAccess.includes(QRP.PRODUCTS.RENTERS) && res.productAccess.includes(QRP.PRODUCTS.AUTO)) {
        res.productAccess.push(QRP.PRODUCTS.RA_BUNDLE);//TODO
      }
      if (typeof res.productAccess === 'object') {
        for (let i = 0; i < productOrder.length; i += 1) {
          if (res.productAccess.includes(productOrder[i])) {
            this.productButtonsData.values.push(filters.search_products_with_icons[productOrder[i]]);
          }
        }
      } else {
        const productAccessArray = res.productAccess.split(',');

        for (let i = 0; i < productOrder.length; i += 1) {
          if (productAccessArray.includes(productOrder[i])) {
            this.productButtonsData.values.push(filters.search_products_with_icons[productOrder[i]]);
          }
        }
      }

      if (res.productAccess.length === 1) {
        this.productButtonsData.field_value = res.productAccess[0]; // the single product is set as the selected one
      }

      this.insuranceType = [];
      this.insuranceType = this.productButtonsData;

      console.log('importEpicData about to run');
      this.importEpicData();
    });
    }
  // agent name check end here
    this.flowType = sessionStorage.getItem('flowType');
    const requestParam = {
      url: this.$store.getters.getNavLink,
    };
    /**
     * Below is where we utilize our 'import fetchData' to get ALL the data needed to render this page:
     * multiple fields which could have values already in them from a previous session,
     * contents of Help/Script and Quote Summary, State of the navigation buttons, errors associated
     * with a specific field, and more.
     */
    const startTimeVal = (new Date()).getTime();
    fetchData.getPageData(requestParam).then((response) => {
      // log API response time through application into GA tool
      common.gapRecordAnalyticsGeneric(startTimeVal, 'API', response.data.page_name);
      this.pageData = response.data;
      this.renderAlert = true;
      this.pageFieldsArray = this.pageData.fields;
      if((this.flowType === 'bundle' || this.flowType === 'cabundle'  || this.flowType === 'rabundle') && this.isPolicyBound()) {
        sessionStorage.setItem('autobound', true);
        if (response.data.quote_summary.binding_carrier) {
          //Store bind quote details in session storage for bundle quote
          let bindDetails = {
            'quote_status' : response.data.quote_summary.binding_carrier.carrier_real_bind_indicator === true ? 'EBound' : 'NEBound',
            'carrier_id' : response.data.quote_summary.binding_carrier.carrier_id,
            'carrier_code' : response.data.quote_summary.binding_carrier.carrier_code,              
            'quote_bind_type' : response.data.quote_summary.binding_carrier.quote_bind_type,
          }
          sessionStorage.setItem('autoBindDetails', JSON.stringify(bindDetails));
        }
      }
      this.pageFieldsArray.forEach((element) => {
        if (!this.colsArray.find(el => el === element.section)) {
          this.colsArray.push(element.section);
        }
      });

      this.pageFieldsArray_1 = this.pageFieldsArray.slice(0, 6); // TODO: Use config values
      this.pageFieldsArray_2 = this.pageFieldsArray.slice(6);
      /**
       * Because component's data needs to be able to affect other component's
       * data, the data is stored in the Vuex state management store.
       */
      this.$store.mutatable_data = this.pageFieldsArray;

      /* collect blurb data in blurbs array based on position */
      for (let blurb = 0; blurb < this.pageData.blurbs.length; blurb += 1) {
        if (!this.blurbs[this.pageData.blurbs[blurb].location]) {
          this.blurbs[this.pageData.blurbs[blurb].location] = [];
        }
        this.blurbs[this.pageData.blurbs[blurb].location].visible = this.pageData.blurbs[blurb].visible;
        this.blurbs[this.pageData.blurbs[blurb].location].content = this.pageData.blurbs[blurb].content;
      }
      common.gapRecordAnalytics(response.data.page_name);
    });
    // set coliumns 1 and 2 using pageFieldsArray
  },
  mounted() {
    /* eslint no-undef: */
    /* eslint prefer-template:  */
  },
  updated() {
  },
};
</script>

<style scoped>
/***header/footer information blurb***/
@media all and (max-width: 992px) {
  .alert.alert-primary{
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/interview/Auto/RC1/NameInsured.vue?1585c638